var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Instagram",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.02 22.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11,2c2.94,0,3.29,0,4.44.06a6,6,0,0,1,2,.38,3.65,3.65,0,0,1,2.09,2.09,6,6,0,0,1,.38,2C20,7.67,20,8,20,11s0,3.29-.06,4.44a6,6,0,0,1-.38,2,3.65,3.65,0,0,1-2.09,2.09,6,6,0,0,1-2,.38c-1.16.05-1.51.06-4.44.06s-3.29,0-4.44-.06a6,6,0,0,1-2-.38,3.65,3.65,0,0,1-2.09-2.09,6,6,0,0,1-.38-2C2,14.23,2,13.88,2,11s0-3.29.06-4.44a6,6,0,0,1,.38-2A3.65,3.65,0,0,1,4.56,2.42a6,6,0,0,1,2-.38C7.72,2,8.07,2,11,2m0-2C8,0,7.64,0,6.46.05A8.11,8.11,0,0,0,3.79.56,5.61,5.61,0,0,0,.57,3.78,8.11,8.11,0,0,0,.06,6.45C0,7.62,0,8,0,11s0,3.36.07,4.54A8.11,8.11,0,0,0,.57,18.2a5.61,5.61,0,0,0,3.22,3.22,8.11,8.11,0,0,0,2.67.51C7.63,22,8,22,11,22s3.36,0,4.54-.07a8.11,8.11,0,0,0,2.67-.51,5.61,5.61,0,0,0,3.22-3.22,8.11,8.11,0,0,0,.51-2.67C22,14.36,22,14,22,11s0-3.36-.07-4.54a8.11,8.11,0,0,0-.51-2.67A5.61,5.61,0,0,0,18.21.56,8.11,8.11,0,0,0,15.54.05C14.37,0,14,0,11,0Z",
    transform: "translate(0.01 0.02)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11,5.35A5.65,5.65,0,1,0,16.65,11h0A5.65,5.65,0,0,0,11,5.35Zm0,9.32A3.67,3.67,0,1,1,14.67,11,3.67,3.67,0,0,1,11,14.67Z",
    transform: "translate(0.01 0.02)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.88,
    cy: 5.15,
    r: 1.32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4da69a6e272e71703f615d12d0d83b3c.svg";
export { ForwardRef as ReactComponent };